export const GET_CUSTOMERS = 'GET_CUSTOMER'
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMER_SUCCESS'
export const GET_CUSTOMERS_FAILED = 'GET_CUSTOMER_FAILED'
export const SEARCH_CUSTOMER = 'SEARCH_CUSTOMER'
export const SEARCH_CUSTOMER_SUCCESS = 'SEARCH_CUSTOMER_SUCCESS'
export const SEARCH_CUSTOMER_FAILED = 'SEARCH_CUSTOMER_FAILED'

export const GET_ECOMM_DATA = 'GET_ECOMM_DATA'
export const GET_ECOMM_DATA_SUCCESS = 'GET_ECOMM_DATA_SUCCESS'
export const GET_ECOMM_DATA_FAILED = 'GET_ECOMM_DATA_FAILED'
export const GET_CUSTOMER_PROFILE_DATA = 'GET_CUSTOMER_PROFILE_DATA'
export const GET_CUSTOMER_PROFILE_DATA_SUCCESS = 'GET_CUSTOMER_PROFILE_DATA_SUCCESS'
export const GET_CUSTOMER_PROFILE_DATA_FAILED = 'GET_CUSTOMER_PROFILE_DATA_FAILED'
export const GET_DELIVERY = 'GET_DELIVERY'
export const GET_DELIVERY_SUCCESS = 'GET_DELIVERY_SUCCESS'
export const GET_DELIVERY_FAILED = 'GET_DELIVERY_FAILED'

export const PRECONDITION_STATUS_CHECK = 'PRECONDITION_STATUS_CHECK'
export const PRECONDITION_STATUS_CHECK_SUCCESS = 'PRECONDITION_STATUS_CHECK_SUCCESS'
export const PRECONDITION_STATUS_CHECK_FAILED = 'PRECONDITION_STATUS_CHECK_FAILED'

export const GET_MODULES = 'GET_MODULES'
export const GET_MODULES_SUCCESS = 'GET_MODULES_SUCCESS'
export const GET_MODULES_FAILED = 'GET_MODULES_FAILED'
export const GET_MODULES_SAVE = 'GET_MODULES'
export const GET_MODULES_SAVE_SUCCESS = 'GET_MODULES_SUCCESS'
export const GET_MODULES_SAVE_FAILED = 'GET_MODULES_FAILED'

export const GET_CONCEPTS_PROFILE = 'GET_CONCEPTS_PROFILE'
export const GET_CONCEPTS_PROFILE_SUCCESS = 'GET_CONCEPTS_PROFILE_SUCCESS'
export const GET_CONCEPTS_PROFILE_FAILED = 'GET_CONCEPTS_PROFILE_FAILED'

export const GET_ECOM_PACKAGES_REQUEST = 'GET_ECOM_PACKAGES_REQUEST'
export const GET_ECOM_PACKAGES_SUCCESS = 'GET_ECOM_PACKAGES_SUCCESS'
export const GET_ECOM_PACKAGES_FAILURE = 'GET_ECOM_PACKAGES_FAILURE'

export const SEND_CONFIRMATION_EMAIL = 'SEND_CONFIRMATION_EMAIL'
export const SEND_CONFIRMATION_EMAIL_SUCCESS = 'SEND_CONFIRMATION_EMAIL_SUCCESS'
export const SEND_CONFIRMATION_EMAIL_FAILED = 'SEND_CONFIRMATION_EMAIL_FAILED'

export const RESENT_LINK = 'RESENT_LINK'
export const RESENT_LINK_SUCCESS = 'RESENT_LINK_SUCCESS'
export const RESENT_LINK_FAILED = 'RESENT_LINK_FAILED'

export const CHECK_STATUS_FOR_RESENT_LINK = 'CHECK_STATUS_FOR_RESENT_LINK'
export const CHECK_STATUS_FOR_RESENT_LINK_SUCCESS = 'CHECK_STATUS_FOR_RESENT_LINK_SUCCESS'
export const CHECK_STATUS_FOR_RESENT_LINK_FAILED = 'CHECK_STATUS_FOR_RESENT_LINK_FAILED'
export interface SearchCustomerQueryObjectTypes {
  Query: string
  OuName: string
  AppId: string
  ModuleID: string
  ActivationStatus: string
  EcommerceStatus: string
  SalesRep: string
}

export type FiltrerAction =
  | { type: 'UPDATE_QUERY'; payload: string }
  | { type: 'UPDATE_MODULE_ID'; payload: string }
  | { type: 'UPDATE_ACTIVATION_STATUS'; payload: string }
  | { type: 'UPDATE_ECOMMERCE_STATUS'; payload: string }
  | { type: 'RESET_FILTERS' }
  | { type: 'UPDATE_APP_ID'; payload: string }
  | { type: 'UPDATE_OU_NAME'; payload: string }

export const EMAIL_CONTENT_MODIFICATION = 'EMAIL_CONTENT_MODIFICATION'
export const EMAIL_CONTENT_MODIFICATION_SUCCESS = 'EMAIL_CONTENT_MODIFICATION_SUCCESS'
export const EMAIL_CONTENT_MODIFICATION_FAILED = 'EMAIL_CONTENT_MODIFICATION_FAILED'

export const FETCH_ATTACHMENT = 'FETCH_ATTACHMENT'
export const FETCH_ATTACHMENT_SUCCESS = 'FETCH_ATTACHMENT_SUCCESS'
export const FETCH_ATTACHMENT_FAILED = 'FETCH_ATTACHMENT_FAILED'

export const FETCH_EMAIL_TEMPLATES = 'FETCH_EMAIL_TEMPLATES'
export const FETCH_EMAIL_TEMPLATES_SUCCESS = 'FETCH_EMAIL_TEMPLATES_SUCCESS'
export const FETCH_EMAIL_TEMPLATES_FAILED = 'FETCH_EMAIL_TEMPLATES_FAILED'

export const FETCH_EMAIL_CONTENT = 'FETCH_EMAIL_CONTENT'
export const FETCH_EMAIL_CONTENT_SUCCESS = 'FETCH_EMAIL_CONTENT_SUCCESS'
export const FETCH_EMAIL_CONTENT_FAILED = 'FETCH_EMAIL_CONTENT_FAILED'
